export default __webpack_public_path__ + "static/media/ic_select_indicator.712f2e7e.svg";